<template>
  <v-container>
    <v-spacer class="custom-spacer"></v-spacer>
    <v-row>
      <v-col>
        <h2 class="heading-2">Team</h2>
        <br />

        <h3 class="heading-3">
          Jason Scharf - Founder / Civic Software Developer
        </h3>
        <br>
        <br>

      <v-row>
        <v-col>
          <v-img
            :src="require('../assets/jason-WS-v2.jpeg')"
            alt="Business headshot"
            class="my-3"
            contain
            max-width="400px"
        />
        </v-col>

        <v-col>
          <p itemid="team-text">
          I am a hard worker, who enjoys learning and facing new challenges. I am skilled at managing multiple projects, meeting deadlines, while always striving to provide excellent customer service to clients and stakeholders.
          <br>
          <br>

I would love to help you or your team increase their ability to obtain, manage, and get insights from your data!
&bull;
        </p>
        <br>
        <br>

        <h2 class="heading-2">Experience</h2>
        <br />

        <h3 class="heading-3">
          City of Syracuse — Deputy Director of Digital Services
        </h3>
        <h5 class="heading-5">
          December 2024 - Present
        </h5>
        <br />

        <p>
          &bull; Helping to lead a team of civic web and software developers, product owners, and software trainers to improve resident services in the City of Syracuse.
        </p>

        <h3 class="heading-3">
          City of Syracuse — Data Program Manager
        </h3>
        <h5 class="heading-5">
          January 2022 - December 2024
        </h5>
        <br />


        <p>
          &bull; Managed
          <a href="https://data.syr.gov/"> Open Data Syracuse</a>, the City's
          Open Data Portal website.
        </p>
        <p>
          &bull; Increased transparency and performance monitoring by making maps and data visualizations in ArcGIS, PowerBI, and Tableau that were fed by real-time civic data.
        </p>
        <br />
        <br />

        <h3 class="heading-3">
          Kirkwork Software Development — Software Developer
        </h3>
        <h5 class="heading-5">
          January 2021 - November 2021
        </h5>
        <br />

        <p>
          &bull; Assisted in adding features to an  interactive desktop software application, using Vue.js, customer databases, RESTful API’s, and Postman for API testing.
        </p>
        <br>

        <v-col align-self="center">
        <b>Connect with Jason</b>

        <v-btn
          href="https://www.linkedin.com/in/jason-d-scharf"
          class="mx-4 teal--text"
          icon
        >
          <v-icon size="48px">
            mdi-linkedin
          </v-icon>
        </v-btn>
  
   </v-col>

        </v-col>

      </v-row>



      </v-col>
    </v-row>

    <v-row>
      <v-col>
      </v-col>
    </v-row>
    <br />
    <br />
    <br />

    <br />
    <button>
      <div class="text-button">
        <v-btn
          to="/contact"
          depressed
          elevation="10"
          color="#2c8591"
          raised
          rounded
          dark
        >
          Schedule a Free Consult
        </v-btn>
      </div>
    </button>

    <br />
    <br />
    <br />
  </v-container>
</template>

<script>
export default {
  name: "OurTeam",
  components: {},
};
</script>

<style>
.game-container {
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 35px;
  height: 0;
  overflow: hidden;
}
</style>
